import React, { Component } from "react";
import { Link } from "gatsby";

class IndustriesSection extends Component {
  render() {
    return (
      <section id="industries-section">
        <div className="container d-flex justify-content-center">
          <div className="row  industries-desc">
            <div className="col-12 text-center mt-5 mb-5">
              <p className="head-top-desc">Our Industries</p>
              <h2 className="my-h2-head mb-md-4">Their Confidence</h2>

              <p className="desc">
                Providing our expertise in these two industries in both Dental
                and Chiropractic care is the reason why we strive for success
                each and everyday, and is the key reason what motivates us to do
                better.
              </p>

              <p className="desc mb-md-5">
                There is no better feeling than seeing the confidence in our
                Friends and Family. And providing our service all across Ontario
                and soon to be Nation wide makes it all the better!
              </p>

              <Link className=" hero-cta-button " to="/">
                Descover More
              </Link>
              <img
                className="img-fluid"
                src={require("../../../static/images/home-working-process-img.png")}
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default IndustriesSection;
